import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import ChangePassword from "@/pages/ChangePassword";
import Admin from "@/pages/Admin";
import Dashboard from "@/pages/Dashboard";
import PublicMenu from "@/pages/PublicMenu";

function Protected({ children, role }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen bg-[#09090B]" />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <Navigate to="/trocar-senha" replace />;
  if (role && user.role !== role) {
    return <Navigate to={user.role === "superadmin" ? "/admin" : "/painel"} replace />;
  }
  return children;
}

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-center" theme="dark" closeButton toastOptions={{ duration: 3500 }} />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/trocar-senha" element={<ChangePassword />} />
          <Route path="/admin" element={<Protected role="superadmin"><Admin /></Protected>} />
          <Route path="/painel" element={<Protected><Dashboard /></Protected>} />
          <Route path="/painel/:rid" element={<Protected role="superadmin"><Dashboard /></Protected>} />
          <Route path="/:slug" element={<PublicMenu />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
